export const paymentStatus = Object.freeze({
  canceled: 0,
  faulted: 1,
  initialized: 10,
  readyForInvoice: 20,
  directPaymentInProgress: 24, // Direct payment means that payment happens before invoicing
  directPaidReadyForInvoice: 25, // Payment has been received, but not invoiced yet
  scheduledForInvoice: 49,
  waitingForInvoice: 50,
  sentToERP: 60,
  invoicedInERP: 65,
  partlyPaid: 70,
  paid: 80,
});
